/**
 * La marca de inspección terminada, y lo que decide con ella la ruta de la evaluación cuando su chunk no carga.
 *
 * En el documento donde se confirmó el cierre, el error sigue hasta el resumen: con red recarga una vez, y sin
 * red se queda con «Continuar» (`finish.page.ts`, `advanceAfterClose`). En otro documento con la inspección
 * terminada —el de esa recarga, o el link abierto de nuevo— no hay resumen que lo maneje, y el router, sin la
 * ruta, deja la página en blanco. Ahí la ruta carga un respaldo que no viaja en ese chunk: «Tu inspección quedó
 * enviada» con «Reintentar». El respaldo no recarga solo, así que por este camino la recarga automática es a lo sumo
 * una: la del documento del cierre.
 *
 * Antes del cierre no cambia nada: sin la marca de terminada, el error sigue como siempre.
 */
import { isChunkLoadError } from './ChunkLoadRecovery';

/** En `localStorage`. La pone `InspectionControlService.setInspectionAsFinished`, solo con el 200 del cierre. */
export const INSPECTION_FINISHED_KEY = 'inspectionFinished';

let finishedInThisDocument = false;

/** Vive en el módulo y no en `localStorage`: tiene que valer solo para el documento donde se cerró. */
export function markFinishedInThisDocument(): void {
  finishedInThisDocument = true;
}

export function wasFinishedInThisDocument(): boolean {
  return finishedInThisDocument;
}

export function shouldShowEvaluationFallback(error: unknown, finished: boolean, finishedHere: boolean): boolean {
  return finished && !finishedHere && isChunkLoadError(error);
}
